import {isIntegerNumber, getNumberWithoutCommas, isNumWithMaxNDecimals} from '../../../../common/util/fieldsValidation';

const positionRequiredColumns = [0, 2, 4, 5, 6, 7, 8, 9];
const transportsOptions = {
  'A': 'Aéreo',
  'V': 'VOR',
  'S': 'Marítimo',
};
const nameColumns = [
  'CAJA',
  'REF NO',
  'PEDIDO NO',
  'ITEM NO',
  'PARTE NO',
  'NOMBRE PARTE',
  'CANTIDAD',
  'PRECIO UNITARIO',
  'VALOR TOTAL',
  'PESO NETO',
];

export const getProviders = (list) => {
  return list.map((element) => {
    return {'text': `${element.code} - ${element.name}`, 'value': element.code};
  });
};

export const getDealers = (list) => {
  return list.map((element) => {
    return {'text': element.name, 'value': element.identification};
  });
};

export const getTransportsOptions = () => {
  return Object.keys(transportsOptions).map((element) => {
    return {'text': transportsOptions[element], 'value': element};
  });
};

export const getTotalAmount = (list) => {
  let total = 0;
  list.forEach((element) => {
    const amount = parseFloat(element.amount) || 0;
    total += amount;
  });
  return total.toFixed(2);
};

export const getTotalWeight = (list) => {
  let total = 0;
  list.forEach((element) => {
    const weight = parseFloat(element.totalWeight) || 0;
    total += weight;
  });
  return total.toFixed(2);
};

export const getParsedData = (data) => {
  const columnsNumbers = 10;
  const dataParsed = [];
  for (let i = 1; i < data.length; i++) {
    const rowParsed = {};
    for (let j = 0; j < columnsNumbers; j++) {
      switch (j) {
        case 0:
          rowParsed.caseNumber = data[i][j];
          break;
        case 1:
          rowParsed.referenceNumber = data[i][j];
          break;
        case 2:
          rowParsed.orderNumber = data[i][j];
          break;
        case 3:
          rowParsed.itemNumber = data[i][j];
          break;
        case 4:
          rowParsed.partNumber = data[i][j];
          break;
        case 5:
          rowParsed.partName = data[i][j];
          break;
        case 6:
          rowParsed.quantity = parseInt(data[i][j], 10);
          break;
        case 7:
          const price = data[i][j].replace(',', '.');
          rowParsed.unitPrice = parseFloat(price);
          break;
        case 8:
          const amount = data[i][j].replace(',', '.');
          rowParsed.amount = parseFloat(amount);
          break;
        case 9:
          const weight = data[i][j].replace(',', '.');
          rowParsed.weight = parseFloat(weight);
          break;
        default:
          break;
      }
    }
    dataParsed.push(rowParsed);
  }
  return dataParsed;
};

export const requiredFieldIsEmpty = (value, currentColumn) => {
  if (positionRequiredColumns.includes(currentColumn) && !value) {
    return true;
  }
  return false;
};

export const validateRequiredField = (value, currentColumn) => {
  if (requiredFieldIsEmpty(value, currentColumn)) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido.`;
  }
  return '';
};

export const validateQuantityField = (value, currentColumn) => {
  if (
    requiredFieldIsEmpty(value, currentColumn) ||
      !isIntegerNumber(value) ||
      parseInt(value, 10) <= 0
  ) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido y debe ser un valor entero mayor
        a cero.`;
  }
  return '';
};

export const validatePriceField = (value, currentColumn) => {
  if (requiredFieldIsEmpty(value, currentColumn)) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido y debe ser un valor numérico con máximo
        6 decimales mayor a 0.`;
  }
  if (value && value.includes('.')) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, posee un formato incorrecto.`;
  }

  let price = value.replace(',', '.');
  price = value ? parseFloat(price) : 0;
  price = price ? getNumberWithoutCommas(price) : null;

  if (price <= 0 || !isNumWithMaxNDecimals(price, 6)) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, debe ser un valor numérico con máximo 6 decimales
        mayor a 0.`;
  }
  return '';
};

export const validateAmountField = ({value, currentColumn, qty, unitPrice}) => {
  let totalPrice = value.replace(',', '.');
  totalPrice = value ? parseFloat(totalPrice) : 0;
  totalPrice = totalPrice ?
    parseFloat(getNumberWithoutCommas(totalPrice)) :
    null;

  const quantity = qty ? parseInt(qty, 10) : 0;
  let price = unitPrice ? unitPrice.replace(',', '.') : 0;
  price = unitPrice ? parseFloat(price) : 0;
  const totalPriceCalculated = parseFloat((quantity * price).toFixed(2));

  if (
    totalPrice <= 0 ||
      (isIntegerNumber(quantity) &&
        isNumWithMaxNDecimals(price, 6) &&
        totalPrice !== totalPriceCalculated)
  ) {
    return ` Verifique el valor del campo ${nameColumns[currentColumn]}, no corresponde al valor esperado.`;
  }
  return '';
};

export const validateWeightField = (value, currentColumn) => {
  if (requiredFieldIsEmpty(value, currentColumn)) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido y debe ser un valor numérico con máximo
        6 decimales mayor a 0.`;
  }
  if (value && value.includes('.')) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, posee un formato incorrecto.`;
  }

  let weight = value.replace(',', '.');
  weight = value ? parseFloat(weight) : 0;
  weight = weight ? getNumberWithoutCommas(weight) : null;

  if (weight <= 0 || !isNumWithMaxNDecimals(weight, 6)) {
    return ` Verifique el campo ${nameColumns[currentColumn]}, debe ser un valor numérico con máximo 6 decimales
        mayor a 0.`;
  }
  return '';
};

export const validateData = (data, hasToVerfyWeight) => {
  const columnsNumbers = 10;
  const rowsWithErrors = [];

  for (let i = 1; i < data.length; i++) {
    let errorsByRow = '';
    for (let j = 0; j < columnsNumbers; j++) {
      const value = data[i][j].toString();
      const currentColumn = j;
      switch (currentColumn) {
        case 0:
        case 2:
        case 4:
        case 5:
          errorsByRow += validateRequiredField(value, currentColumn);
          break;
        case 6:
          errorsByRow += validateQuantityField(value, currentColumn);
          break;
        case 7:
        case 8:
          const errorByRequiredField = validatePriceField(
            value,
            currentColumn
          );
          errorsByRow += errorByRequiredField;

          if (currentColumn === 7 || errorByRequiredField) {
            break;
          }

          const qty = data[i][6];
          const unitPrice = data[i][7].toString();
          errorsByRow += validateAmountField({
            value,
            currentColumn,
            qty,
            unitPrice,
          });
          break;
        case 9:
          errorsByRow += hasToVerfyWeight ?
            validateWeightField(value, currentColumn) :
            '';
          break;
        default:
          break;
      }
    }
    if (errorsByRow) {
      rowsWithErrors.push({'row': i + 1, 'message': errorsByRow});
    }
  }
  return rowsWithErrors;
};
